export class MiscUtil {
  static uuid(): string {
    return window.crypto.getRandomValues(new Uint32Array(3))?.[0]?.toString(36);
  }
}
